import TaskQueue from 'app/utils/queues/TaskQueue';
import { IAgent, IValueTransformTask, IValueTransformMiddleware } from 'app/utils/queues/constants';

export interface IAgentInit<T> {
  init: T;
  middleware?: IValueTransformMiddleware<T>;
}

export default class Agent<T> implements IAgent<T> {
  private value: T;
  private middleware: IValueTransformMiddleware<T>;
  private queue = new TaskQueue();

  public constructor({
    init,
    middleware = (value, task, cancelToken) => task(value, cancelToken),
  }: IAgentInit<T>) {
    this.value = init;
    this.middleware = middleware;
  }

  public update(task: IValueTransformTask<T>) {
    return this.queue.push(async (cancelToken) => {
      const value = await this.middleware(this.value, task, cancelToken);
      this.value = value;
      return value;
    });
  }

  public abort() {
    return this.queue.abort();
  }
}
